module.exports = __webpack_public_path__ + "static/media/nodejs.f34a0218.jpeg";